import { hostname } from '~/constantDefinitions';
import { datadogRum } from '@datadog/browser-rum';

export const setHostnameSansAccountKey = (): void => {
  datadogRum.setGlobalContextProperty('hostnameSansAccountKey', hostname);
};
